import { withStyles } from '@material-ui/core/styles';
import MuiTypography from '@material-ui/core/Typography';
import MuiBox from '@material-ui/core/Box';
import MuiSearchIcon from '@mui/icons-material/Search';
import EditQuery from './edit-query';
import DeleteQuery from './delete-query';
import QueryResults from './query-results';

const styles = theme => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid #ccc',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(1),
    maxWidth: '250px',
    '&:hover': {
      backgroundColor: '#fbfbfb',
    },
  },
  title: {
    fontWeight: 'bold',
  },
  prompt: {
    display: 'inline-block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 5,
    marginBottom: 10,
  },
});

const AvailableQuery = ({ query_library_prompt_id, title, prompt, refetch, ...props }) => {
  const { classes } = props;
  return (
    <MuiBox className={classes.container}>
      <MuiBox className={classes.header}>
        <QueryResults prompt={prompt} title={title}>
          <MuiSearchIcon />
        </QueryResults>
        <EditQuery id={query_library_prompt_id} title={title} prompt={prompt} refetch={refetch} />
        <DeleteQuery id={query_library_prompt_id} refetch={refetch} />
      </MuiBox>
      <MuiTypography variant="body1" className={classes.title}>
        {title}
      </MuiTypography>
      <MuiTypography variant="body2" className={classes.prompt}>
        {prompt}
      </MuiTypography>
    </MuiBox>
  );
};

export default withStyles(styles)(AvailableQuery);
